// src/components/forms/fields/TextField.tsx
// Utworzony w Krok 3

import React from 'react';
import { TextField as MuiTextField, Box } from '@mui/material';
import { FormSection } from '../../../types/forms';

interface TextFieldProps {
  section: FormSection;
  value: string | undefined;
  onChange: (value: string) => void;
  error?: string;
}

export const TextField: React.FC<TextFieldProps> = ({ section, value, onChange, error }) => {
  const isMultiline = section.config?.multiline || false;
  const rows = section.config?.rows || 3;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <Box sx={{ mb: 3 }}>
      <MuiTextField
        fullWidth
        multiline={isMultiline}
        rows={isMultiline ? rows : 1}
        label={section.label}
        value={value || ''}
        onChange={handleChange}
        error={!!error}
        helperText={error || section.description}
        required={!!section.validation?.required}
        variant="outlined"
        size="medium"
        sx={{
          '& .MuiInputBase-root': {
            minHeight: isMultiline ? 'auto' : '56px',
          },
        }}
      />
    </Box>
  );
};